import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/icon';
import '@/utils/permission';
import '@/assets/tailwindcss.css'

Vue.config.productionTip = false;

import request from '@/utils/request'

Vue.prototype.$http = function DeptAppSave(url, data) {
  return request({
    url: url,
    method: 'post',
    data
  })
}

Vue.prototype.$isxj = window['pathConfig'][process.env.NODE_ENV].isxunjee

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
